/**
 * lib/fbSdk.js — lazy-loaded Facebook JS SDK.
 *
 * The Facebook SDK script is fetched on-demand the first time someone clicks
 * "Continue with Facebook" so we never pay the kilobytes when the feature is
 * disabled or unused. Returns the live `window.FB` global.
 */
let sdkPromise = null;

export function loadFbSdk(appId, version = "v19.0") {
    if (typeof window === "undefined") return Promise.reject(new Error("No window"));
    if (sdkPromise) return sdkPromise;
    sdkPromise = new Promise((resolve, reject) => {
        // If the SDK already exists, just init it and resolve.
        if (window.FB) {
            try {
                window.FB.init({ appId, cookie: false, xfbml: false, version });
                resolve(window.FB);
            } catch (e) { reject(e); }
            return;
        }
        // Async init handler the SDK calls once it has finished loading.
        window.fbAsyncInit = function () {
            try {
                window.FB.init({ appId, cookie: false, xfbml: false, version });
                resolve(window.FB);
            } catch (e) { reject(e); }
        };
        const script = document.createElement("script");
        script.id = "facebook-jssdk";
        script.async = true;
        script.defer = true;
        script.crossOrigin = "anonymous";
        script.src = "https://connect.facebook.net/en_US/sdk.js";
        script.onerror = () => reject(new Error("Failed to load Facebook SDK"));
        document.body.appendChild(script);
    });
    return sdkPromise;
}
